export function stringValue(value?:string){
  return value === undefined || value === null ? '' : value;
}